const instantInkStyles = styles => {
  return `
    .ink table.mail,
    .ink h1, .ink h2, .ink h3, .ink h4, .ink h5, .ink h6,
    .ink p,
    .ink td{
      color: ${styles["base-font-color"]} !important;
    }
    .ink table.mail,
    .ink p,
    .ink td {
      font-size: ${styles["body-font-size"]} !important;
    }
    .ink,
    .ink table.mail,
    .ink h1, .ink h2, .ink h3, .ink h4, .ink h5, .ink h6,
    .ink p,
    .ink td {
      font-family: ${styles["base-font-family"]} !important;
    }
    .ink .mail a {
      color: ${styles["anchor-font-color"]};
    }
    .ink a[data-mce-href] {
      color: ${styles["anchor-font-color"]};
    }
    .ink h1 {
      font-family: ${styles["h1-font-family"]} !important;
      font-size: ${styles["h1-font-size"]} !important;
      color: ${styles["h1-font-color"]} !important;
    }
    .ink h2 {
      font-family: ${styles["h2-font-family"]} !important;
      font-size: ${styles["h2-font-size"]} !important;
      color: ${styles["h2-font-color"]} !important;
    }
    .ink h3 {
      font-family: ${styles["h3-font-family"]} !important;
      font-size: ${styles["h3-font-size"]} !important;
      color: ${styles["h3-font-color"]} !important;
    }

    .ink h4 {
      font-family: ${styles["h4-font-family"]} !important;
      font-size: ${styles["h4-font-size"]} !important;
      color: ${styles["h4-font-color"]} !important;
    }
    .ink h5 {
      font-family: ${styles["h5-font-family"]} !important;
      font-size: ${styles["h5-font-size"]} !important;
      color: ${styles["h5-font-color"]} !important;
    }
    .ink h6 {
      font-family: ${styles["h6-font-family"]} !important;
      font-size: ${styles["h6-font-size"]} !important;
      color: ${styles["h6-font-color"]} !important;
    }
    .ink td.wrapper {
      padding-top: ${styles["wrapper-padding-top"]} !important;
      position: relative;
    }
    .ink table.columns > tbody > tr > td,
    .ink table.column > tbody > tr > td {
      padding: 0px 0px ${styles["column-cell-padding-bottom"]};
    }
    .fantastic-section--all-empty.fantastic-section--resizing .empty table.columns .ftc-column--empty .ftc-drop--ITEM .fantastic-item__empty {
      top: -${styles["column-cell-padding-bottom"]};
      min-height: calc(${styles["column-cell-padding-bottom"]} + 20px);
    }
    .fantastic-section--resizing .empty table.columns .ftc-column--empty .ftc-drop--ITEM .fantastic-item__empty {
      top: ${styles["column-cell-padding-bottom"]};
      bottom: ${styles["column-cell-padding-bottom"]};
    }
    .fantastic-section--resizing table.columns:after {
      top: 0;
      bottom: ${styles["column-cell-padding-bottom"]};
    }
    .ink table.container table.row {
      padding: 0px ${styles["row-padding"]};
    }
    .ink p {
      margin-bottom: ${styles["paragraph-margin-bottom"]} !important;
    }
  `;
};

export default instantInkStyles;
